import React, { useEffect, useState } from 'react';
import { ExternalLink } from 'lucide-react';

function App() {
  const [isVisible, setIsVisible] = useState(false);
  const newWebsiteUrl = 'https://finecut.com';

  useEffect(() => {
    // Trigger fade-in animation
    setTimeout(() => setIsVisible(true), 100);
  }, []);

  const handleManualRedirect = () => {
    window.location.href = newWebsiteUrl;
  };

  return (
    <div 
      data-component-path="client/src/App.jsx" 
      data-component-line="1:1" 
      data-component-id="client/src/App.jsx:1:1"
      className="min-h-screen bg-black flex items-center justify-center p-4 relative overflow-hidden"
    >
      {/* Cinematic background gradient overlay */}
      <div 
        data-component-path="client/src/App.jsx" 
        data-component-line="2:3" 
        data-component-id="client/src/App.jsx:2:3"
        className="absolute inset-0 bg-gradient-to-br from-blue-950/20 via-transparent to-blue-950/20"
      />
      
      {/* Radial gradient for depth */}
      <div 
        data-component-path="client/src/App.jsx" 
        data-component-line="3:3" 
        data-component-id="client/src/App.jsx:3:3"
        className="absolute inset-0 bg-gradient-radial from-blue-950/10 via-transparent to-transparent"
      />

      <div 
        data-component-path="client/src/App.jsx" 
        data-component-line="4:3" 
        data-component-id="client/src/App.jsx:4:3"
        className={`max-w-4xl w-full relative z-10 transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
      >
        <div 
          data-component-path="client/src/App.jsx" 
          data-component-line="5:4" 
          data-component-id="client/src/App.jsx:5:4"
          className="bg-gradient-to-b from-gray-900/80 to-black/80 backdrop-blur-xl border border-blue-900/30 rounded-3xl shadow-2xl shadow-blue-950/50 p-8 md:p-16 text-center relative overflow-hidden"
        >
          {/* Subtle top glow effect */}
          <div 
            data-component-path="client/src/App.jsx" 
            data-component-line="6:5" 
            data-component-id="client/src/App.jsx:6:5"
            className="absolute top-0 left-1/2 -translate-x-1/2 w-3/4 h-px bg-gradient-to-r from-transparent via-blue-500/50 to-transparent"
          />

          {/* Main Heading - Shorter and mobile-friendly */}
          <h1 
            data-component-path="client/src/App.jsx" 
            data-component-line="7:5" 
            data-component-id="client/src/App.jsx:7:5"
            className="text-3xl md:text-5xl lg:text-6xl font-bold text-blue-400 mb-8 tracking-wide"
            style={{ textShadow: '0 0 30px rgba(59, 130, 246, 0.5)' }}
          >
            DOMAIN MOVED
          </h1>

          {/* Divider line */}
          <div 
            data-component-path="client/src/App.jsx" 
            data-component-line="8:5" 
            data-component-id="client/src/App.jsx:8:5"
            className="w-24 h-1 bg-gradient-to-r from-transparent via-blue-500 to-transparent mx-auto mb-8"
          />

          {/* Message */}
          <div 
            data-component-path="client/src/App.jsx" 
            data-component-line="9:5" 
            data-component-id="client/src/App.jsx:9:5"
            className="mb-12 space-y-6"
          >
            <p 
              data-component-path="client/src/App.jsx" 
              data-component-line="10:6" 
              data-component-id="client/src/App.jsx:10:6"
              className="text-lg md:text-xl lg:text-2xl text-gray-300 tracking-wide"
            >
              <span 
                data-component-path="client/src/App.jsx" 
                data-component-line="11:7" 
                data-component-id="client/src/App.jsx:11:7"
                className="font-bold text-white text-xl md:text-2xl lg:text-3xl"
              >
                yiquart.com
              </span>
            </p>
            <p 
              data-component-path="client/src/App.jsx" 
              data-component-line="12:6" 
              data-component-id="client/src/App.jsx:12:6"
              className="text-base md:text-lg lg:text-xl text-gray-400 tracking-wider"
            >
              is no longer in use from 2026
            </p>
            
            <div 
              data-component-path="client/src/App.jsx" 
              data-component-line="13:6" 
              data-component-id="client/src/App.jsx:13:6"
              className="pt-4"
            >
              <p 
                data-component-path="client/src/App.jsx" 
                data-component-line="14:7" 
                data-component-id="client/src/App.jsx:14:7"
                className="text-base md:text-lg lg:text-xl text-gray-400 mb-4 tracking-wide"
              >
                We've moved to our new website
              </p>
              <a 
                data-component-path="client/src/App.jsx" 
                data-component-line="15:7" 
                data-component-id="client/src/App.jsx:15:7"
                href={newWebsiteUrl}
                className="inline-flex items-center gap-2 md:gap-3 text-2xl md:text-4xl lg:text-5xl font-bold text-blue-400 hover:text-blue-300 transition-all duration-300 tracking-wide"
                style={{ textShadow: '0 0 20px rgba(59, 130, 246, 0.4)' }}
              >
                finecut.com
                <ExternalLink 
                  data-component-path="client/src/App.jsx" 
                  data-component-line="16:8" 
                  data-component-id="client/src/App.jsx:16:8"
                  className="w-6 h-6 md:w-8 md:h-8 lg:w-10 lg:h-10" 
                />
              </a>
            </div>
          </div>

          {/* Manual Redirect Button */}
          <div 
            data-component-path="client/src/App.jsx" 
            data-component-line="17:5" 
            data-component-id="client/src/App.jsx:17:5"
            className="pt-8 border-t border-blue-900/30"
          >
            <p 
              data-component-path="client/src/App.jsx" 
              data-component-line="18:6" 
              data-component-id="client/src/App.jsx:18:6"
              className="text-gray-500 mb-6 text-xs md:text-sm tracking-widest uppercase"
            >
              Click below to continue
            </p>
            <button
              data-component-path="client/src/App.jsx" 
              data-component-line="19:6" 
              data-component-id="client/src/App.jsx:19:6"
              onClick={handleManualRedirect}
              className="group inline-flex items-center justify-center gap-2 md:gap-3 h-14 md:h-16 px-8 md:px-12 bg-gradient-to-r from-blue-600 to-blue-500 text-white text-base md:text-lg font-bold rounded-xl hover:from-blue-500 hover:to-blue-400 focus:ring-4 focus:ring-blue-500/50 transition-all duration-300 shadow-lg shadow-blue-600/40 hover:shadow-blue-500/60 hover:shadow-2xl transform hover:-translate-y-1 tracking-wide uppercase"
            >
              Visit Finecut.com
              <ExternalLink 
                data-component-path="client/src/App.jsx" 
                data-component-line="20:7" 
                data-component-id="client/src/App.jsx:20:7"
                className="w-5 h-5 md:w-6 md:h-6 group-hover:translate-x-1 transition-transform duration-300" 
              />
            </button>
          </div>
        </div>

        {/* Footer Note */}
        <p 
          data-component-path="client/src/App.jsx" 
          data-component-line="21:4" 
          data-component-id="client/src/App.jsx:21:4"
          className="text-center text-gray-600 text-xs md:text-sm lg:text-base mt-8 tracking-wider"
        >
          Thank you for your patience during this transition
        </p>
      </div>
    </div>
  );
}

export default App;